module.exports = __webpack_public_path__ + "img/48.051d9936.png";